// extracted by mini-css-extract-plugin
export default {"time":"practice-times-schedule-overview-time_time__H7mpD"};